import { CountdownTime } from "../components/module/proposal-status/modal/preview-proposal/proposal/proposal-count-down";

export const formatDateTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();

    // ✅ UTC day comparison
    const utcNow = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate()
    );

    const utcDate = Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate()
    );

    const diffDays = Math.floor((utcNow - utcDate) / (1000 * 60 * 60 * 24));

    // UTC time
    const time = date
        .toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "UTC",
        })
        .toUpperCase();

    const weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];

    const weekday = weekdays[date.getUTCDay()];

    // 1. TODAY → only time
    if (diffDays === 0) {
        return time;
    }

    // 2. YESTERDAY → special label
    if (diffDays === 1) {
        return `Yesterday ${time}`;
    }

    // 3. within 7 days → weekday + time
    if (diffDays <= 7) {
        return `${weekday} ${time}`;
    }

    // 4. more than 7 days → full date + time
    const formattedDate = date.toLocaleDateString("en-US", {
        timeZone: "UTC",
    });

    return `${formattedDate} ${time}`;
};


export const formatDateTimeChatMessage = (dateString: string) => {
    const date = new Date(dateString);

    const formattedDate = date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        timeZone: "UTC",
    });

    const formattedTime = date
        .toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "UTC",
        })
        .toUpperCase();

    return `${formattedDate} ${formattedTime}`;
}

export const getTimeLeftProposal = (expiryDate: string) => {
    const total = new Date(expiryDate).getTime() - new Date().getTime();

    if (total <= 0) {
        return {
            expired: true,
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };
    }

    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((total / (1000 * 60)) % 60);
    const seconds = Math.floor((total / 1000) % 60);

    return {
        expired: false,
        days,
        hours,
        minutes,
        seconds,
    };
}

export const formatCountDown = (time: CountdownTime) => {
    const parts = [];

    if (time.days > 0) {
        parts.push(`${time.days}d`);
    }

    if (time.hours > 0) {
        parts.push(`${time.hours}h`);
    }

    parts.push(`${time.minutes}m`);

    // ✅ only show seconds when NO days and NO hours
    if (time.days === 0 && time.hours === 0) {
        parts.push(`${time.seconds}s`);
    }

    return parts.join(" ");
}